import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";
import { StatementState } from "models/statement";

const initialState: StatementState = {
  loading: false,
  data: {},
  message: "",
  success: false,
};

const statementSlice = createSlice({
  name: "statement",
  initialState,
  reducers: {
    getStatement(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
      state.data = {};
    },
    getStatementSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = action.payload;
      state.success = true;
    },
    getStatementFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = {};
      state.message = action.payload.message;
      state.success = false;
    },
    clearData(state) {
      state.loading = false;
      state.message = "";
      state.success = false;
      state.updateMessage = "";
      state.deleteMessage = "";
      state.imageUrl = "";
    },
  },
});

//Actions
export const statementAction = statementSlice.actions;

//Selectors
export const getStatementData = (state: RootState) => state.statement.data;
export const selectIsLoading = (state: RootState) => state.statement.loading;
export const getStatementSuccess = (state: RootState) =>
  state.statement.success;

//Reducers
const statementReducer = statementSlice.reducer;
export default statementReducer;
